import React from "react";
import StudentTab from "../components/students/studentTab.jsx";

export const Students = () => {
    return (
        <div className="p-4  w-full ">
            <StudentTab />
        </div>
    );
};
         

export default Students;
